<template>
  <!-- 通用白板页面 author: zhangxiaofeng -->
  <div class="board-page--main">
    <header-general type="board" :page-title="pageTitle" />
    <slot></slot>
    <footer-general class="footer-instance"></footer-general>
  </div>
</template>
<style lang="less" type="text/less" scoped>
  .board-page--main{
    *{
      box-sizing: content-box;
    }
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    position: relative;
    /*padding-top: 96px;*/
    /*padding-bottom: 42px;*/
    background-color: #F3F4F7;
    .footer-instance{
      position: fixed;
      bottom: 0;
      width: 100%;
      background-color: #F3F4F7;
      padding-bottom: 20px;
    }
  }
</style>
<script>
import HeaderGeneral from '_c/common/Header/HeaderGeneral.vue'
import FooterGeneral from '_c/common/Footer/FooterGeneral.vue'
export default {
  name: 'PageBoard',
  props: {
    pageTitle: {
      type: String,
      default: ''
    }
  },
  components: {
    HeaderGeneral,
    FooterGeneral
  }
}
</script>
